import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static outlets = ['character'];
  static values = { id: Number, url: String };
  static effects = ['show_on_character'];

  characterOutletConnected() { this.dispatch('ready'); }
  urlValueChanged() { this.dispatch('ready'); }

  get screenCharacter() {
    const screen = this.element.closest('[data-controller~="automation"]');
    return this.characterOutlets.find(character => character.element.closest('[data-controller~="automation"]') === screen);
  }

  beginEvaluation() {
    this.screenCharacter?.beginAutomation();
  }

  show_on_character(automationId) {
    const character = this.screenCharacter;
    if (character?.claimAutomation(automationId)) character.updateSrc(this.urlValue);
  }

  finishEvaluation() {
    this.screenCharacter?.finishAutomation();
  }
}
